import d from './debug.amd'
const log = d('.jslibs')
log('loaded...')

export { default as debug } from './debug.amd'
export { default as Emittery } from 'emittery'

// import * as pastelColor from 'pastel-color'
// console.warn({pastelColor})

export * as pastelColor from 'pastel-color'
export { debounce } from 'perfect-debounce'